import type { DocEntityBase } from "building-types/entities/docEntityBase";
import type { Table } from "common/data/table";
import objectKeyFilter from "common/utils/objectKeyFilter";
import { sortEntitiesBySortIndex } from "common/utils/sortIndex";

export function docEntityGetSortedChildrenFromArray<T extends DocEntityBase<any>>(
  entities: T[],
  parentId: string,
): T[] {
  return sortEntitiesBySortIndex(docEntityGetChildrenFromArray(entities, parentId));
}

export function docEntityGetChildrenFromArray<T extends DocEntityBase<any>>(entities: T[], parentId: string): T[] {
  return entities.filter((e) => e.parentId === parentId);
}

export function docEntityGetChildrenFromTable<T extends DocEntityBase<any>>(
  table: Table<T>,
  parentId: string,
): Table<T> {
  const nestedEntityTable: { [id: string]: T } = {};

  for (const entityId in table) {
    const entity = table[entityId];

    if (entity.parentId !== parentId) {
      continue;
    }

    nestedEntityTable[entityId] = entity;
  }

  return nestedEntityTable;
}

export function docEntityGetChildEntityIdsFromTable<T extends DocEntityBase<any>>(
  entities: Table<T>,
  parentId: string,
): string[] {
  return docEntityGetSortedEntityIdsFromTable(objectKeyFilter(entities, (id) => entities[id].parentId === parentId));
}

export function docEntityGetSortedChildrenFromTable<T extends DocEntityBase<any>>(
  entities: Table<T>,
  parentId: string,
): T[] {
  const children: T[] = [];
  for (const entityId in entities) {
    const entity = entities[entityId];
    if (entity.parentId !== parentId) {
      continue;
    }
    children.push(entity);
  }
  return sortEntitiesBySortIndex(children);
}

export function docEntityGetSortedEntityIdsFromTable<T extends DocEntityBase<any>>(entityTable: Table<T>): string[] {
  return Object.keys(entityTable).sort((a, b) => (entityTable[a].sortIndex > entityTable[b].sortIndex ? 1 : -1));
}
